import React, { ReactElement } from "react";

export const DashIcon = (): ReactElement => (
  <svg
    width="76"
    height="12"
    viewBox="0 0 76 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.33 6L40.67 6"
      stroke="#3B414E"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
  </svg>
);
